//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2024, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */

const training_reports = () => import("../components/training_reports.vue");
const trainingReport_add = () => import("../components/trainingReport_add.vue");
/* const training_add_add_row = () =>
  import("../components/training_add_add_row.vue"); */
const afteraction_reports = () =>
  import("../components/afteraction_reports.vue");
const afteractionReport_add = () =>
  import("../components/afteractionReport_add.vue");
/* const afteraction_add_add_row = () =>
  import("../components/afteraction_add_add_row.vue"); */
const roster_logs = () => import("../components/roster_logs.vue");
const data_table = () => import("../components/data_table.vue");
const home = () => import("../components/home.vue");
const reports = () => import("../components/reports.vue");
const whatsNext = () => import("../components/whatsNext.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");

export const routes = [
  {
    name: "training_reports",
    path: "/",
    component: training_reports,
    display: "Training Reports",
  },

  {
    name: "trainingReport_add",
    path: "/trainingReport_add",
    component: trainingReport_add,
    display: "trainingReport_add",
  },

  /*   {
    name: "training_add_add_row",
    path: "/training_add_add_row",
    component: training_add_add_row,
    display: "training_add_add_row",
  }, */

  {
    name: "afteraction_reports",
    path: "/afteraction_reports",
    component: afteraction_reports,
    display: "afteraction_reports",
  },

  {
    name: "afteractionReport_add",
    path: "/afteractionReport_add",
    component: afteractionReport_add,
    display: "afteractionReport_add",
  },

  /*   {
    name: "afteraction_add_add_row",
    path: "/afteraction_add_add_row",
    component: afteraction_add_add_row,
    display: "afteraction_add_add_row",
  }, */
  //reports
  {
    name: "reports",
    path: "/reports",
    component: reports,
    display: "reports",
  },
  {
    name: "roster_logs",
    path: "/roster_logs",
    component: roster_logs,
    display: "roster_logs",
  },
  {
    name: "data_table",
    path: "/data_table",
    component: data_table,
    display: "data_table",
  },

  {
    name: "home",
    path: "/home",
    component: home,
    display: "home",
  },

  {
    name: "whatsNext",
    path: "/whatsNext",
    component: whatsNext,
    display: "whatsNext",
  },

  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
